'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var core = require('@material-ui/core');
var styledComponents = require('./styled-components.js');

var OutlinedInputWithTopLabel = function (props) {
    var title = props.title, value = props.value, reporter = props.reporter, placeholder = props.placeholder, _a = props.fullWidth, fullWidth = _a === void 0 ? true : _a, error = props.error, _b = props.type, type = _b === void 0 ? 'text' : _b, disabled = props.disabled, inputComponent = props.inputComponent, maxLength = props.maxLength, onBlur = props.onBlur;
    var _c = React.useState(value), param = _c[0], setParam = _c[1];
    var handleChange = function (event) {
        setParam(event.target.value);
        reporter(event.target.value);
    };
    return (React__default.createElement(styledComponents.Main, null,
        title && (React__default.createElement(styledComponents.StyledInputLabel, null,
            React__default.createElement(core.Typography, { variant: 'body2' }, title))),
        React__default.createElement(styledComponents.StyledInput, { value: param, fullWidth: fullWidth, onChange: handleChange, inputProps: {
                'data-testid': 'title-input',
                maxLength: maxLength,
            }, error: error, placeholder: placeholder || '', type: type, disabled: disabled, inputComponent: inputComponent, onBlur: onBlur, notched: false, color: 'secondary' })));
};

module.exports = OutlinedInputWithTopLabel;
